import { CommonService } from './../services/common/common.service';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import { MESSAGE, API_STATUS } from '../constants/config';
import { Router } from '@angular/router';
import { headersToString } from 'selenium-webdriver/http';
@Injectable()
export class CommonHttpInterceptor implements HttpInterceptor {
  headers: any;
  constructor(private _common: CommonService, private router: Router) {
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // const headers = new HttpHeaders().set('Content-Type', 'application/json');
    if (localStorage.getItem('CURRENT_USER') && JSON.parse(localStorage.getItem('CURRENT_USER')).login_token) {
      this.headers = new HttpHeaders().set('login-token', JSON.parse(localStorage.getItem('CURRENT_USER')).login_token);
    }
    return next.handle(req.clone({
      headers: this.headers,
      withCredentials: true,
    })).do((event: HttpEvent<any>) => {
      if (event['body']) {
        if (event['body'].Status === API_STATUS.access_denied) {
          this._common.showToastr('error', 'Access is denied', 'An error occured!');
          localStorage.removeItem('CURRENT_USER');
          this.router.navigate(['/landing']);
        }
      }
    }, (err: any) => {
      this._common.showToastr('error', MESSAGE.error_connect, 'An error occured!');
      if (err instanceof HttpErrorResponse) {
        // do error handling here
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/interceptor/common.interceptor.ts